import { Icon, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { CardContent, Stack, Tooltip, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import type { EntityInfoPanelProps as Props } from './types';

export const EntityInfoPanel = memo(
  ({
    className,
    children,
    badge,
    icon,
    iconSize,
    iconColor,
    title,
    titleInfo,
    subTitle,
    headerPadding,
    contentPadding,
    sx,
    titleSx,
    headerSx,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('EntityInfoPanel', className)}
        sx={mergeSx(sx)}
        variant="outlined"
        headerDivider
      >
        {title && (
          <Styled.Header
            sx={headerSx}
            padding={headerPadding ?? 'extra'}
            title={
              title && (
                <Stack direction="row" alignItems="center" gap={0.5}>
                  {!!icon && (
                    <Icon
                      name={icon}
                      size={iconSize ?? 24}
                      color={iconColor ?? 'primary.500'}
                    />
                  )}
                  {!!badge && (
                    <Label variant="filled" color="primary">
                      <Typography variant="body3" color="white">
                        {badge}
                      </Typography>
                    </Label>
                  )}

                  <Typography
                    variant="body3"
                    fontWeight={600}
                    color="grey.700"
                    sx={titleSx}
                  >
                    {title}
                  </Typography>
                  {titleInfo && (
                    <Tooltip title={titleInfo}>
                      <Icon size={18} name="info" />
                    </Tooltip>
                  )}
                </Stack>
              )
            }
            subheader={subTitle}
          />
        )}
        <CardContent padding={contentPadding ?? 'none'}>{children}</CardContent>
      </Styled.Wrapper>
    );
  }
);

EntityInfoPanel.displayName = 'EntityInfoPanel';
